import type { SVGProps } from 'react';

export type IconName =
  | 'accounts'
  | 'alert'
  | 'arrow'
  | 'bell'
  | 'calculator'
  | 'calendar'
  | 'cash'
  | 'check'
  | 'chevron'
  | 'close'
  | 'cloud'
  | 'cloudOff'
  | 'copy'
  | 'dashboard'
  | 'device'
  | 'dock'
  | 'download'
  | 'exchange'
  | 'float'
  | 'fullscreen'
  | 'fullscreenOff'
  | 'history'
  | 'info'
  | 'install'
  | 'inventory'
  | 'journal'
  | 'layout'
  | 'lock'
  | 'maximize'
  | 'menu'
  | 'minimize'
  | 'moon'
  | 'microphone'
  | 'microphoneOff'
  | 'more'
  | 'payables'
  | 'payroll'
  | 'plus'
  | 'purchase'
  | 'receivables'
  | 'restore'
  | 'reports'
  | 'sales'
  | 'search'
  | 'send'
  | 'settings'
  | 'splitBeside'
  | 'splitBelow'
  | 'shield'
  | 'sparkle'
  | 'speaker'
  | 'speakerOff'
  | 'stop'
  | 'sun'
  | 'sync'
  | 'trash'
  | 'trend'
  | 'user'
  | 'warehouse';

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
}

export function Icon({ name, className = 'icon', ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...props}
    >
      {name === 'dashboard' && <><rect x="3" y="3" width="7" height="7" rx="2" /><rect x="14" y="3" width="7" height="4" rx="2" /><rect x="14" y="11" width="7" height="10" rx="2" /><rect x="3" y="14" width="7" height="7" rx="2" /></>}
      {name === 'journal' && <><path d="M6 3h9l3 3v15H6z" /><path d="M14 3v4h4M9 11h6M9 15h6" /></>}
      {name === 'accounts' && <><path d="M4 20h16M5 9h14M7 9v8M12 9v8M17 9v8" /><path d="m3 7 9-4 9 4z" /></>}
      {name === 'exchange' && <><path d="M7 7h12l-3-3M17 17H5l3 3" /><path d="m19 7-3 3M5 17l3-3" /></>}
      {name === 'inventory' && <><path d="m4 7 8-4 8 4-8 4z" /><path d="M4 7v10l8 4 8-4V7M12 11v10" /></>}
      {name === 'reports' && <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></>}
      {name === 'info' && <><circle cx="12" cy="12" r="9" /><path d="M12 11v5" /><path d="M12 8h.01" /></>}
      {name === 'receivables' && <><circle cx="12" cy="12" r="9" /><path d="M8 12h8M12 8v8M17.5 6.5l-11 11" /></>}
      {name === 'payables' && <><circle cx="12" cy="12" r="9" /><path d="M8 12h8M17.5 6.5l-11 11" /></>}
      {name === 'payroll' && <><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M8 7h8M8 11h8M8 15h3" /><circle cx="16" cy="16" r="2.5" /></>}
      {name === 'purchase' && <><path d="M3 5h2l2 11h10l2-8H6" /><circle cx="9" cy="20" r="1" /><circle cx="17" cy="20" r="1" /></>}
      {name === 'sales' && <><path d="M4 4h16v12H4zM8 20h8M12 16v4" /><path d="m8 11 3-3 2 2 3-3" /></>}
      {name === 'settings' && <><circle cx="12" cy="12" r="3" /><path d="M19 13.5v-3l-2-.7-.7-1.7.9-1.9-2.1-2.1-1.9.9-1.7-.7L10.5 2h-3l-.7 2-1.7.7-1.9-.9-2.1 2.1.9 1.9-.7 1.7-2 .7v3l2 .7.7 1.7-.9 1.9 2.1 2.1 1.9-.9 1.7.7.7 2h3l.7-2 1.7-.7 1.9.9 2.1-2.1-.9-1.9.7-1.7z" transform="scale(.8) translate(3 3)" /></>}
      {name === 'search' && <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>}
      {name === 'bell' && <><path d="M18 9a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7" /><path d="M10 20h4" /></>}
      {name === 'user' && <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>}
      {name === 'menu' && <path d="M4 7h16M4 12h16M4 17h16" />}
      {name === 'close' && <path d="m6 6 12 12M18 6 6 18" />}
      {name === 'check' && <path d="m5 12.5 4.5 4.5L19 7" />}
      {name === 'copy' && <><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h8" /></>}
      {name === 'chevron' && <path d="m9 18 6-6-6-6" />}
      {name === 'arrow' && <path d="M5 12h14m-5-5 5 5-5 5" />}
      {name === 'more' && <><circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" /></>}
      {name === 'alert' && <><path d="M12 3 2.5 20h19z" /><path d="M12 9v4M12 17h.01" /></>}
      {name === 'calendar' && <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /></>}
      {name === 'calculator' && <><rect x="4" y="3" width="16" height="18" rx="2" /><rect x="7" y="6" width="10" height="3.5" rx="1" /><path d="M8 13h.01M12 13h.01M16 13h.01M8 17h.01M12 17h.01M16 17h.01" /></>}
      {name === 'cash' && <><rect x="3" y="6" width="18" height="12" rx="2" /><circle cx="12" cy="12" r="3" /><path d="M7 9H5v2M17 15h2v-2" /></>}
      {name === 'warehouse' && <><path d="m3 10 9-6 9 6v10H3z" /><path d="M8 20v-6h8v6M7 10h.01M12 10h.01M17 10h.01" /></>}
      {name === 'trend' && <path d="m3 17 6-6 4 4 8-9M16 6h5v5" />}
      {name === 'sparkle' && <><path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2z" /><path d="m18 14 .7 2.3L21 17l-2.3.7L18 20l-.7-2.3L15 17l2.3-.7z" /></>}
      {name === 'sun' && <><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></>}
      {name === 'moon' && <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />}
      {name === 'microphone' && <><rect x="9" y="3" width="6" height="12" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3M9 21h6" /></>}
      {name === 'microphoneOff' && <><path d="M9 9V6a3 3 0 0 1 5.9-.7M15 11.4V12a3 3 0 0 1-3.6 2.9" /><path d="M5 11a7 7 0 0 0 10.3 6.2M19 11a7 7 0 0 1-.5 2.6M12 18v3M9 21h6" /><path d="m4 3 16 18" /></>}
      {name === 'speaker' && <><path d="M5 9H2v6h3l5 4V5z" /><path d="M14 9a4 4 0 0 1 0 6M17 6a8 8 0 0 1 0 12" /></>}
      {name === 'speakerOff' && <><path d="M5 9H2v6h3l5 4V5z" /><path d="m15 10 5 5M20 10l-5 5" /></>}
      {name === 'cloud' && <path d="M7 19a4 4 0 0 1-.4-8A6 6 0 0 1 18 9.7 3.7 3.7 0 0 1 17.5 19z" />}
      {name === 'cloudOff' && <><path d="M7 19a4 4 0 0 1-.4-8 6 6 0 0 1 2-3.2M11 6.2A6 6 0 0 1 18 9.7 3.7 3.7 0 0 1 17.5 19h-6" /><path d="m3 3 18 18" /></>}
      {name === 'sync' && <><path d="M20 12a8 8 0 0 1-13.7 5.6M4 12a8 8 0 0 1 13.7-5.6" /><path d="M17 3v4h-4M7 21v-4h4" /></>}
      {name === 'download' && <><path d="M12 4v11" /><path d="m7 11 5 5 5-5" /><path d="M4 20h16" /></>}
      {name === 'install' && <><rect x="4" y="3" width="16" height="18" rx="3" /><path d="M12 8v6m-2.5-2.5L12 14l2.5-2.5" /></>}
      {name === 'device' && <><rect x="3" y="4" width="12" height="9" rx="2" /><path d="M7 17h5" /><rect x="15" y="10" width="6" height="11" rx="2" /></>}
      {name === 'lock' && <><rect x="4" y="10" width="16" height="11" rx="2.5" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14.5v2.5" /></>}
      {name === 'shield' && <><path d="M12 3l7 3v6c0 4.2-2.8 7.6-7 9-4.2-1.4-7-4.8-7-9V6z" /><path d="m9 12 2 2 4-4" /></>}
      {name === 'trash' && <><path d="M4 7h16M10 4h4M9 7v11M15 7v11" /><path d="M6 7l1 13h10l1-13" /></>}
      {name === 'history' && <><path d="M3.6 9.5A9 9 0 1 1 3 13" /><path d="M3 4.5V10h5.5" /><path d="M12 7.5V12l3.5 2.2" /></>}
      {name === 'send' && <><path d="M20 4 3.5 11.2l6.6 2.7L13 20z" /><path d="m10.1 13.9 4.4-4.4" /></>}
      {name === 'stop' && <rect x="7" y="7" width="10" height="10" rx="2.5" />}
      {name === 'plus' && <path d="M12 5v14M5 12h14" />}
      {name === 'splitBeside' && <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M12 4v16" /></>}
      {name === 'splitBelow' && <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 12h18" /></>}
      {name === 'maximize' && <rect x="4" y="4" width="16" height="16" rx="2" />}
      {name === 'restore' && <><rect x="9" y="3" width="12" height="12" rx="2" /><path d="M15 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h4" /></>}
      {name === 'minimize' && <path d="M6 17h12" />}
      {/* The maximize square with the middle of each edge taken out: a window with no edges left. */}
      {name === 'fullscreen' && <path d="M9 4H6a2 2 0 0 0-2 2v3M15 4h3a2 2 0 0 1 2 2v3M20 15v3a2 2 0 0 1-2 2h-3M9 20H6a2 2 0 0 1-2-2v-3" />}
      {/* The same four corners turned to face the middle: the room closing again. */}
      {name === 'fullscreenOff' && <path d="M9 4v3a2 2 0 0 1-2 2H4M15 4v3a2 2 0 0 0 2 2h3M20 15h-3a2 2 0 0 0-2 2v3M4 15h3a2 2 0 0 1 2 2v3" />}
      {name === 'float' && <><rect x="3" y="6" width="12" height="12" rx="2" /><path d="M14 3h7v7M21 3l-7 7" /></>}
      {name === 'dock' && <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M14 4v16" /><path d="M6 12h5m-2-2 2 2-2 2" /></>}
      {name === 'layout' && <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M10 9v11" /></>}
    </svg>
  );
}
